import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, ClockIcon, SparklesIcon, StarIcon } from 'lucide-react';
import { CHECKOUT_URL, PRICE_FULL, PRICE_SHORT, Section } from './Shared';
import { Blossom, DropperBottle } from './Decor';
function LaunchUrgency() {
  const [timeLeft, setTimeLeft] = useState({
    h: 0,
    m: 54,
    s: 25
  });
  const spotsTaken = 78;
  useEffect(() => {
    const timer = window.setInterval(() => setTimeLeft(current => {
      const seconds = Math.max(0, current.h * 3600 + current.m * 60 + current.s - 1);
      return {
        h: Math.floor(seconds / 3600),
        m: Math.floor(seconds % 3600 / 60),
        s: seconds % 60
      };
    }), 1000);
    return () => window.clearInterval(timer);
  }, []);
  const format = (value: number) => value.toString().padStart(2, '0');
  const TimeBox = ({
    value,
    label
  }: {
    value: number;
    label: string;
  }) => <div className="flex flex-col items-center" data-id="element-178" data-mp="12r83j73if9ml">
      <div className="min-w-[58px] rounded-xl bg-brand-taupe px-3 py-2 font-mono text-2xl font-bold tabular-nums text-brand-goldLight ring-1 ring-brand-gold/40 md:min-w-[80px] md:px-5 md:py-3 md:text-4xl" data-id="element-179" data-mp="12s10jgco2krj">
        {format(value)}
      </div>
      <span className="mt-1.5 text-[10px] font-semibold uppercase tracking-wider text-brand-muted md:text-sm" data-id="element-180" data-mp="17qkqrsyamipp">
        {label}
      </span>
    </div>;
  return <div className="mx-auto mb-12 max-w-4xl" data-id="element-181" data-mp="1mdnmbu322hae">
      <div className="paper-panel rounded-3xl border-2 border-brand-gold/45 p-6 md:p-8" data-id="element-182" data-mp="1hgx6n7v5xnpi">
        <div className="mb-5 flex items-center justify-center gap-2" data-id="element-183" data-mp="1vfwvogml84m7">
          <ClockIcon className="h-5 w-5 text-brand-goldDark" data-id="element-184" data-mp="1ve2k3sx7hous" />
          <h3 className="font-serif text-base font-bold text-brand-taupe md:text-xl" data-id="element-185" data-mp="1qi55ps5i6skn">
            ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
          </h3>
        </div>
        <div className="mb-5 flex items-center justify-center gap-2 md:gap-4" data-id="element-186" data-mp="3s8owuwa3hap2">
          <TimeBox value={timeLeft.h} label="Horas" data-id="element-187" data-mp="3satai5xspo2j" />
          <span className="pb-5 text-3xl font-bold text-brand-gold" data-id="element-188" data-mp="1w6c3cy42148h">:</span>
          <TimeBox value={timeLeft.m} label="Min" data-id="element-189" data-mp="213vie08ktl1h" />
          <span className="pb-5 text-3xl font-bold text-brand-gold" data-id="element-190" data-mp="214nd78ucneqp">:</span>
          <TimeBox value={timeLeft.s} label="Seg" data-id="element-191" data-mp="262oxfx3ihk3r" />
        </div>
        <div className="mb-6 flex items-center justify-center gap-2 rounded-xl border border-brand-gold/50 bg-brand-goldLight/50 px-4 py-3" data-id="element-192" data-mp="2a5l7gzezk7w3">
          <AlertTriangleIcon className="h-5 w-5 shrink-0 text-brand-goldDark" data-id="element-193" data-mp="2f3n1ughv3tmv" />
          <p className="text-center text-sm font-semibold text-brand-text md:text-base" data-id="element-194" data-mp="2k27sppb850yn">
            Después sube. <span className="text-brand-sageMid" data-id="element-195" data-mp="2ov0zeiq96jdd">No vuelve.</span>
          </p>
        </div>
        <div className="rounded-2xl border border-brand-taupe/15 bg-white p-4 md:p-5" data-id="element-196" data-mp="2ts11kijzf1z7">
          <div className="mb-3 flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between" data-id="element-197" data-mp="2xvfircjnpoe8">
            <span className="flex items-center gap-2 text-sm font-semibold text-brand-text md:text-base" data-id="element-198" data-mp="32sz9vd1gdvnl">
              <span className="relative flex h-2.5 w-2.5" data-id="element-199" data-mp="r7gklnjkkds2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-gold opacity-75" data-id="element-200" data-mp="m7anvsyg0134" />
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-brand-gold" data-id="element-201" data-mp="i57cf4brwwhu" />
              </span>
              Cupos al precio de lanzamiento
            </span>
            <span className="text-xs font-bold uppercase tracking-wide text-brand-rose" data-id="element-202" data-mp="19wvjbbbs8qta">Quedan pocos</span>
          </div>
          <div className="mb-2 h-2.5 w-full overflow-hidden rounded-full bg-brand-taupe/10" data-id="element-203" data-mp="15uryhw3849vc">
            <div className="h-full rounded-full bg-brand-sageMid" style={{
            width: `${spotsTaken}%`
          }} data-id="element-204" data-mp="1141pm8vl9ovw" />
          </div>
          <p className="text-center text-xs text-brand-muted md:text-sm" data-id="element-205" data-mp="w4feq638gkq9">
            <strong className="text-brand-sageMid" data-id="element-206" data-mp="1tkmakbfpxuej">{spotsTaken}%</strong> de los cupos al precio de lanzamiento ya
            tomados
          </p>
        </div>
      </div>
    </div>;
}
function Pricing() {
  return <Section id="comprar" glow className="my-12 rounded-3xl border-2 border-brand-gold/50 bg-brand-parchment" data-id="element-207" data-mp="18dlk2vx3y2hu">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 -z-10 overflow-hidden rounded-3xl" data-id="element-208" data-mp="1dej1v7e7guit">
        <Blossom className="absolute left-6 top-8 h-20 w-20 text-brand-roseMist" data-id="element-209" data-mp="zfjfk6e60rpt" />
        <DropperBottle className="absolute bottom-6 right-8 hidden h-32 w-16 text-brand-sageMist md:block" data-id="element-210" data-mp="14duli61cai2r" />
      </div>

      <div className="relative mb-10 text-center" data-id="element-211" data-mp="1s3fgjnarp5se">
        <span className="animate-glow-pulse mb-4 inline-flex items-center gap-2 rounded-full bg-brand-taupe px-4 py-1.5 text-[11px] font-bold uppercase tracking-wider text-brand-goldLight md:text-sm" data-id="element-212" data-mp="1w4r29hqit6vb">
          🌸 Oferta de lanzamiento
        </span>
        <h2 className="font-serif text-3xl font-bold text-brand-taupe md:text-4xl" data-id="element-213" data-mp="1n9t33sws4xvj">
          TU <span className="text-brand-goldDark" data-id="element-214" data-mp="2azx3lreo8hib">GUÍA DEFINITIVA DE COSMÉTICA NATURAL</span>
        </h2>
        <p className="mt-3 text-sm font-semibold text-brand-sageMid md:text-base" data-id="element-215" data-mp="2ftj8uyii9j43">
          El precio de lanzamiento vence hoy. Después sube. No vuelve.
        </p>
      </div>

      <div className="mx-auto max-w-2xl space-y-5" data-id="element-216" data-mp="2l4nbsf0o4huz">
        <div className="relative rounded-3xl" data-id="element-217" data-mp="2ywtqdwo6agsb">
          <span className="glow-frame" aria-hidden="true" data-id="element-218" data-mp="2yvietaohk4qn" />
          <div className="relative z-10 rounded-3xl bg-white p-6 shadow-lg md:p-8" data-id="element-219" data-mp="2ty0g0d46n5wd">
            <div className="mb-3 flex items-center gap-1.5 text-brand-goldDark" data-id="element-220" data-mp="26862rufybfbl">
              <SparklesIcon className="h-4 w-4" data-id="element-221" data-mp="26a8qu8xjmydo" />
              <StarIcon className="h-4 w-4 fill-current" data-id="element-222" data-mp="227cgf5i5q8kt" />
              <span className="text-[10px] font-bold uppercase tracking-wider md:text-sm" data-id="element-223" data-mp="228x9srsqjlh3">
                El kit argentino más completo
              </span>
            </div>
            <div className="flex flex-wrap items-end justify-between gap-6" data-id="element-224" data-mp="2b5xrygp7onc3">
              <div className="max-w-md" data-id="element-225" data-mp="3rk7hvf93qk51">
                <h3 className="font-serif text-lg font-bold text-brand-taupe md:text-xl" data-id="element-226" data-mp="3rnbv124joq7u">
                  🌿 COSMÉTICA NATURAL — LA GUÍA DEFINITIVA
                </h3>
                <p className="mt-1 text-sm text-brand-muted" data-id="element-227" data-mp="3umka13zcj9hc">3 Tomos + 6 Bonus · Más de 300 páginas</p>
                <p className="mt-2 text-sm font-medium leading-relaxed text-brand-sageMid" data-id="element-228" data-mp="2hhu1fphmv0w">
                  Recetarios, alquimia vibracional, ingeniería de precios, branding magnético y guiones de venta.
                  Acceso de por vida con actualizaciones futuras incluidas.
                </p>
              </div>
              <div className="shrink-0 text-right" data-id="element-229" data-mp="3ax9w9vj5uylv">
                <p className="text-xs uppercase tracking-wide text-brand-muted" data-id="element-230" data-mp="3fz9179uju3kx">Valor original</p>
                <p className="text-lg text-brand-muted line-through" data-id="element-231" data-mp="3kw979kref6c1">{PRICE_FULL}</p>
                <p className="mt-1 text-xs uppercase tracking-wide text-brand-muted" data-id="element-232" data-mp="3poagsyx6miyd">Precio de lanzamiento</p>
                <p className="font-serif text-4xl font-bold text-brand-taupe md:text-5xl" data-id="element-233" data-mp="2s7lihf7fxytq">{PRICE_SHORT}</p>
                <p className="text-xs text-brand-muted" data-id="element-234" data-mp="2x6ewr9ujxtuy">Acceso inmediato de por vida</p>
              </div>
            </div>
          </div>
        </div>

        <motion.a href={CHECKOUT_URL} whileHover={{
        scale: 1.03
      }} whileTap={{
        scale: 0.98
      }} transition={{
        duration: 0.14,
        ease: [0.23, 1, 0.32, 1]
      }} className="cta-shimmer relative flex w-full justify-center overflow-hidden rounded-full bg-brand-taupe px-6 py-5 text-center text-base font-bold text-brand-cream shadow-[0_12px_28px_rgba(94,74,52,.26)] ring-1 ring-brand-gold/50 md:text-xl" data-id="element-235" data-mp="2kp434scvvpsu">
          <span className="relative z-10" data-id="element-236" data-mp="21xul1up1rspn">QUIERO MI PACK AHORA {PRICE_SHORT} →</span>
        </motion.a>

        <div className="grid gap-3 rounded-2xl bg-brand-sageMist p-4 text-center sm:grid-cols-4" data-id="element-237" data-mp="1x01c4twd0klo">
          {['✓ Acceso inmediato', '✓ 100% PDF', '✓ Garantía 7 días', '✓ Pago seguro'].map(item => <span key={item} className="text-xs font-bold text-brand-sageMid" data-id="element-238" data-mp="1n0u1wfkx962s">
              {item}
            </span>)}
        </div>
      </div>
    </Section>;
}
export function LaunchOffer() {
  return <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-239" data-mp="36udamo1m167d">
      <LaunchUrgency data-id="element-240" data-mp="3bu84n0gombwn" />
      <Pricing data-id="element-241" data-mp="3burj2774ii5x" />
    </div>;
}